import React from 'react';
import {useFormik} from "formik";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@material-ui/core";

const AddProjectDialog = (props) => {
    const {open, onClose, submitCallback} = props

    const onSubmit = async (values) => {
        await submitCallback(values)
    }

    const {getFieldProps, resetForm, submitForm} = useFormik({
        initialValues: {
            name: ''
        },
        onSubmit: onSubmit
    })

    const handleCloseDialog = () => {
        onClose()
        resetForm()
    }

    const handleSubmitButtonClick = async () => {
        await submitForm()
        handleCloseDialog()
    }

    return (
        <Dialog open={open} onClose={handleCloseDialog} maxWidth={"sm"} fullWidth>
            <DialogTitle>Добавить набор документов</DialogTitle>
            <DialogContent>
                <DialogContentText>Введите название</DialogContentText>
                <TextField fullWidth name={'name'} {...getFieldProps('name')}/>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseDialog}>
                    Отмена
                </Button>
                <Button onClick={handleSubmitButtonClick}>
                    Сохранить
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddProjectDialog;